import { useSuspenseQuery } from '@tanstack/react-query';
import { opinetApi as api } from '@/shared/api';
import { stationKeys } from '../api/station.keys';

const useRegionPrice = (lat?: number, lng?: number) => {
	const { data } = useSuspenseQuery({
		queryFn: () => {
			if (lat == null || lng == null) {
				return null;
			}
			return api.getRegionPrice(lat, lng);
		},
		queryKey: stationKeys.regionPrice(lat, lng),
	});

	return data;
};

export default useRegionPrice;
